/**
 * Appointment Rescheduled - Automated Messages Settings
 * Configure messages sent when a client reschedules their appointment in the portal
 */

import { createFileRoute, useParams } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { SettingsPageHeader } from '@/components/ui'
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell'
import { AppointmentRescheduledTimeline } from './automated-messages/components/appointment-rescheduled-timeline'
import { formatDocumentTitle } from '@/lib/document-title'

export const Route = createFileRoute(
  '/_auth/$orgId/settings/automated-messages/appointment-rescheduled',
)({
  component: AppointmentRescheduledPage,
})

function AppointmentRescheduledPage() {
  const { orgId } = useParams({
    from: '/_auth/$orgId/settings/automated-messages/appointment-rescheduled',
  })

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Appointment Rescheduled', 'Automated Messages')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="appointment-rescheduled">
        <SettingsPageHeader
          title="Appointment Rescheduled"
          description="Configure which automated messages are sent when appointments get rescheduled."
        />

        <div className="max-w-3xl">
          <AppointmentRescheduledTimeline />
        </div>
      </BusinessSetupPageShell>
    </>
  )
}
